<template>
  <div v-if="editModeActive">
    <div class="mb-3">
      <text-editor
        class="markdown-text__text"
        :value="value"
        ref="textEditor"
        @input="onInputUpdate"
        @save="onSaveText"
        @cancel="enterEditMode({status: false})" />
    </div>
    <div>
      <!-- INFO: We have to use mousedown.native here otherwise lost focus will fire before the click event -->
      <el-button size="mini" type="success" @click="onSaveTextExternalClick">Save</el-button>
      <el-button size="mini" type="button" @click="enterEditMode({status: false})">Cancel</el-button>
    </div>
  </div>
  <div v-else style="position: relative;">
    <div @click="enterEditMode({status: true})" class="markdown-text__text markdown-body">
      <div v-html="compiledMarkdown"></div>
      <font-awesome-icon
        v-show="isEditable"
        style="cursor: pointer; position: absolute; right: 8px; top: 8px"
        icon="edit"
        @click="enterEditMode({status: !editModeActive})" />
    </div>
  </div>
</template>

<script>
import marked from 'marked'
// import { EventBus } from "@/event-bus"

export default {
  props: {
    value: {},
    enableInlineEditing: {}, // TODO
    placeholder: {
      type: String,
      default: "Try some markdown"
    },
    editOnClick: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      hasUnsavedChanges: false,
      editModeActive: false,
      // internal_text: '',
    };
  },
  watch: {
    // value(new_text) {
      // this.internal_text = new_text;
    // }
  },
  computed: {
    compiledMarkdown() {
      return this.value ? marked(this.value, { sanitize: true }) : '<em>No text</em>';
    }
  },
  created() {
    // this.internal_text = this.text;
  },
  methods: {
    onInputUpdate(value) {
      // console.log("onInputUpdate");
      // this.internal_text = value;
      this.hasUnsavedChanges = true;
    },

    onBlur(value) {
      this.value = value
    },

    onSaveText(value) {
      console.log("onSaveText", value);
      this.$emit('input', value)
      this.hasUnsavedChanges = false;
      this.enterEditMode({ status: false });
    },

    onSaveTextExternalClick() {
      // EventBus.$emit('markdownText-save', true);
      this.$refs.textEditor.onSave();
      // ...or call this.onSaveText( this.$refs.textEditor.value) directly
    },

    enterEditMode({ status }) {
      if ( !this.isEditable ) {
        return
      }
      this.editModeActive = status;
      this.$emit('mode-changed', status)
      // this.$nextTick(() => {
      //   if ( this.$refs.text_input ) {
      //     this.$refs.text_input.focus()
      //   }
      // })
    }
  }
}
</script>

<style>
.markdown-text__text {
  /*
  background-color: rgba(255,255,255,0.95);
  border-radius: 3px;
  position: relative;
  padding: 5px 30px 5px 5px;
  filter: drop-shadow(3px 2px 4px #dddddd);
  */
}
.markdown-text__text ul {
  list-style-type: disc;
}
</style>
